import { Icons, StateCard } from './StateCard.js';

/**
 * The screen a section gets when the organisers have hidden it.
 *
 * Its wording comes from the API (`comingSoonCopy`), not from a string literal
 * here — the same reason the block and field catalogs are served rather than
 * enumerated client-side (design §8.2). An organiser who wants different words
 * gets them without a frontend release.
 *
 * It is deliberately *not* an error, an empty list, or a 404: an attendee who
 * taps Schedule before the organisers have published one should see something
 * that reads like it was designed, in their event's own colours.
 */
export function ComingSoon({ title, body }: { title: string; body: string }) {
  return <StateCard icon={Icons.clock} title={title} body={body} tone="neutral" />;
}
